import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useIsMobile from '../../../hooks/useIsMobile';

/*
 * Curvas da marca. No desktop a curva nasce no canto inferior esquerdo e morre
 * no canto superior direito, deixando o azul à direita e abaixo dela. No mobile
 * é a mesma linguagem, mas rasa, cobrindo só a faixa do rodapé.
 */
const CURVAS = {
    desktop: {
        /*
         * S de canto a canto: os pontos de controle ficam colados na base e no
         * topo (y=100 e y=0), o que dá tangente horizontal nas duas pontas — a
         * curva corre rente à base à esquerda, sobe cortando o meio da tela
         * (passa por ~56%,50%) e deita na borda de cima até o canto direito.
         */
        area: 'M 0 100 C 48 100, 54 0, 100 0 L 100 100 Z',
        borda: 'M 0 100 C 48 100, 54 0, 100 0',
        sombra: 'M 0 90 C 42 90, 48 -6, 92 -6'
    },
    mobile: {
        area: 'M 0 100 C 25 88, 60 74, 100 40 L 100 100 Z',
        borda: 'M 0 100 C 25 88, 60 74, 100 40',
        sombra: 'M 0 92 C 24 81, 58 66, 100 30'
    }
};

const useStyles = makeStyles({
    svg: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'block',
        zIndex: 0,
        pointerEvents: 'none'
    }
});

export default function FundoCurvaUnaerp() {
    const classes = useStyles();
    const theme = useTheme();
    const { azulEscuro, azulClaro, amarelo } = theme.palette.marca;
    const azulMarca = theme.palette.primary.main;
    const isMobile = useIsMobile();
    const curva = isMobile ? CURVAS.mobile : CURVAS.desktop;

    return (
        <svg
            className={classes.svg}
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            aria-hidden="true"
            focusable="false">
            <defs>
                <linearGradient id="fundoCurvaUnaerp" x1="0" y1="1" x2="1" y2="0">
                    <stop offset="0%" stopColor={azulEscuro} />
                    <stop offset="60%" stopColor={azulMarca} />
                    <stop offset="100%" stopColor={azulClaro} />
                </linearGradient>
            </defs>

            {/* Traço de apoio atrás da curva principal, só para dar profundidade. */}
            <path
                d={curva.sombra}
                fill="none"
                stroke={azulMarca}
                strokeOpacity={0.14}
                strokeWidth={2}
                vectorEffect="non-scaling-stroke"
            />
            <path d={curva.area} fill="url(#fundoCurvaUnaerp)" />
            {/*
             * non-scaling-stroke é obrigatório: com preserveAspectRatio="none" o
             * desenho é esticado e, sem isso, a espessura da linha distorce junto.
             */}
            <path
                d={curva.borda}
                fill="none"
                stroke={amarelo}
                strokeWidth={3}
                vectorEffect="non-scaling-stroke"
            />
        </svg>
    );
}
